import { PERMISSIONS, type PermissionCode } from '@/lib/permissions'

/**
 * What a branch operator's morning screen is catalogued to show and cannot yet — this module's own
 * version of `LedgerCapabilityGaps` and `ReportsCapabilityGaps`. Read before assuming a tile that is
 * missing means nobody thought of it.
 */
export interface DashboardCapabilityGap {
  title: string
  permission: PermissionCode
  detail: string
}

export const DASHBOARD_CAPABILITY_GAPS: DashboardCapabilityGap[] = [
  {
    title: 'Group meetings due today has no endpoint to read it from',
    permission: PERMISSIONS.groups.view,
    detail:
      '`GET /groups` carries `nextMeetingDate` on every row, but there is no calendar or "due today" query behind it — answering "how many meetings today" for a branch would mean paging through every one of its groups and comparing dates in the browser. This pass does not attempt that: a page-size cap chosen on this screen would silently undercount a busy branch on a page nobody would think to doubt, which is exactly the wrong way for a dashboard figure to be wrong. An operator can already see each group\'s next meeting date by eye on the collection worklist.',
  },
]
